import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MdError, MdRefresh } from 'react-icons/md';
import classes from './ErrorBoundary.module.scss';

const useRouteChange = () => {
    const location = window.location;
    useEffect(() => {
        const handleUrlChange = () => {
            return location.search;
        };
        handleUrlChange();
    }, [location.search]);
};

function withRouteChangeEffect(Component) {
    return function WrappedComponent(props) {
        const routeChangeValue = useRouteChange() || window.location.search;
        return <Component {...props} routeChangeValue={routeChangeValue} />;
    };
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error Boundary Caught:', error, errorInfo);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.routeChangeValue !== this.props.routeChangeValue) {
            this.setState({
                hasError: false,
                error: null,
            });
        }
    }

    handlePageRefresh = () => {
        window.sessionStorage.clear();
        window.location.reload(true);
    };

    render() {
        const { error, hasError } = this.state;
        if (hasError && error.name === 'ChunkLoadError') {
            return (
                <div className={classes.ErrorBoundary}>
                    <div className={classes.ErrorContainer}>
                        <div className={classes.ErrorIcon}>
                            <MdError size="4rem" />
                        </div>
                        
                        <h1 className={classes.ErrorTitle}>Oops! something went wrong</h1>
                        
                        <p className={classes.ErrorMessage}>
                            Something went wrong while loading the page. Please refresh and try again.
                        </p>
                        
                        <div className={classes.ErrorActions}>
                            <button 
                                className={classes.ReloadButton}
                                onClick={this.handlePageRefresh}
                                type="button"
                            >
                                <MdRefresh size="1.5rem" />
                                Retry Loading
                            </button>
                        </div>

                        <div className={classes.SupportMessage}>
                            <p className={classes.SupportParaqraph}>
                                If the problem persists, please try refreshing the page or contact support at 
                                <strong className={classes.SupportText}> support@grayquest.com</strong>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default withRouteChangeEffect(ErrorBoundary);
